import { GiveawayConfigApiClient } from '@fourthwall/services/dist/GiveawayConfigApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useGiveawayConfigMutation = createMutationHook(
  GiveawayConfigApiClient.updateGiveawayConfig,
  {
    mutationKey: ['giveawayConfig'],
  },
)
